module.exports = __webpack_public_path__ + "img/KSAT25-45-1500-2-btn.f5bd7d02.png";